module.exports = __webpack_public_path__ + "static/hpaLogo-d3e46d704b06b2644c7b86bc8ef90894.png";